<template>
  <SidebarLayout>
    <!-- Sidebar -->
    <template v-slot:sidebar="{ sidebar }">
      <div class="d-flex flex-column my-4">
        <v-btn v-for="item in menu" :key="item.tab" text :block="sidebar" @click="tab = item.tab" :icon="!sidebar" color="white" :title="item.title" :class="['mb-4', sidebar ? 'left-align-btn' : 'mx-auto']">
          <v-icon :left="sidebar">{{ item.icon }}</v-icon> <span v-if="sidebar">{{ item.title }}</span>
        </v-btn>
      </div>
    </template>
    <!-- Main -->
    <template v-slot:main>
      <StoryCreator v-if="tab === 0" />
      <StoryPreview v-if="tab === 1" />
      <StoryEditor v-if="tab === 2" />
      <StoryWorldBuilding v-if="tab === 3" />
      <StoryCharacters v-if="tab === 4" />
      <StorySettings v-if="tab === 5" />
    </template>
  </SidebarLayout>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase/init'

import SidebarLayout from '@/layouts/Sidebar.vue'
import StoryCreator from '@/components/stories/StoryCreator.vue';
import StoryPreview from '@/components/stories/StoryPreview.vue';
import StoryEditor from '@/components/stories/StoryEditor.vue';
import StoryWorldBuilding from '@/components/stories/StoryWorldBuilding.vue';
import StoryCharacters from '@/components/stories/StoryCharacters.vue';
import StorySettings from '@/components/stories/StorySettings.vue';

export default {

  name: 'RealmStory',
  
  components: {
    SidebarLayout,
    StoryCreator,
    StoryPreview,
    StoryEditor,
    StoryWorldBuilding,
    StoryCharacters,
    StorySettings,
  },

  data() {
    return {
      tab: 0,
      story: null,
      loading: false,
      sparkyCollapsed: false,
      previewDialog: false,
      pages: [
        { title: 'Opening', summary: '', content: '', imageUrl: '', showImage: false },
      ],
      menu: [
        { title: 'Creator', icon: 'mdi-creation', tab: 0 },
        { title: 'Preview', icon: 'mdi-book-open-variant-outline', tab: 1 },
        { title: 'Editor', icon: 'mdi-feather', tab: 2 },
        { title: 'World Building', icon: 'mdi-earth-box', tab: 3 },
        { title: 'Characters', icon: 'mdi-wizard-hat', tab: 4 },
        { title: 'Settings', icon: 'mdi-cog-outline', tab: 5 },
      ]
    }
  },

  methods: {

    intitialize() {
      // Load the story from Firestore or Create a new one
      this.loading = true;
      let storyId = this.$route.params.id;
      if (storyId) {
        this.loadStory(storyId);
      }
    },

    loadStory(storyId) {
      // Load the story from Firestore
      const storyRef = doc(db, 'stories', storyId);
      getDoc(storyRef).then((doc) => {
        this.story = doc.data();
        this.story.id = doc.id;
        this.loading = false;
      });
    },
  },

  mounted() {
    this.intitialize()
  }
}
</script>
